export default "__VITE_ASSET__DGGWgo6G__"